import { render, staticRenderFns } from "./VideoCom.vue?vue&type=template&id=7b25e7b6&scoped=true&"
import script from "./VideoCom.vue?vue&type=script&lang=js&"
export * from "./VideoCom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b25e7b6",
  null
  
)

export default component.exports